import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetBranches, EditBranch, CreateBranch, DeleteBranch } from './branchesAction'
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import isEmpty from 'lodash.isempty';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import { LogoutAction } from '../../actions';
import { Prompt } from "react-router-dom";

class Branch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      branchField: '',
      branchFieldError: false,
      branchID: '',
      editMode: false,
      newBranch: '',
      editedBranch: '',
      deleteBranch: '',
      isDeleteContactDialogOpen: false,
      errorMessage: '',
      isBlocking: false,
      errorField: false,
      accessErrorDialog: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.branches) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetBranches } = this.props
    GetBranches()
  }


  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { branches_list, new_branch, edited_branch, delete_success, error_validation, access_error, message_valid } = this.props
    const { branchID } = this.state
    if (nextProps.branches_list !== branches_list) {
      this.setState({ listData: nextProps.branches_list })
    }
    else if (nextProps.new_branch !== new_branch) {
      this.setState({ newBranch: nextProps.new_branch, branchID: nextProps.new_branch.id, isBlocking: false, editMode: true })
    }
    else if (nextProps.edited_branch !== edited_branch) {
      this.setState({ editedBranch: nextProps.edited_branch, isBlocking: false, })
    } else if (nextProps.delete_success !== delete_success) {
      this.setState({ deleteBranch: branchID, branchField: '', isBlocking: false, editMode: false, })
    }
    else if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ errorMessage: nextProps.error_validation, errorField: true })
    }
    else if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  getBranchdata = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      this.setState({ branchID: item.id, errorMessage: '', errorField: false, branchField: item.name, editMode: true })
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getBranchdata(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  editBranch = () => {
    const { branchID, branchField } = this.state
    const { EditBranch } = this.props
    EditBranch(branchID, branchField)
  }

  createBranch = () => {
    const { CreateBranch } = this.props
    const { branchField } = this.state
    if (branchField !== '') {
      CreateBranch(branchField)
    } else {
      this.setState({ branchFieldError: true })
    }
  }
  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }
  deleteBranch = () => {
    const { DeleteBranch } = this.props
    const { branchID } = this.state
    DeleteBranch(branchID)
    this.setState({ isDeleteContactDialogOpen: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }

  resetForm = () => {
    this.setState({ branchField: '', errorMessage: "", isBlocking: false, errorField: false, branchID: '', editMode: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { deleteBranch, accessErrorDialog, isBlocking, isDeleteContactDialogOpen, editMode, listData, branchField, errorMessage, errorField, newBranch, editedBranch } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(errorMessage.message) ?
              <Fragment>
                <Grid item md={3} sm={4} xs={12}>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neue Branche"}
                      listData={listData}
                      newList={newBranch}
                      editedList={editedBranch}
                      deleteList={deleteBranch}
                      getDataOfSelectedItemFunc={this.getBranchdata}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.branches)}

                    />
                  </div>
                </Grid>
                <Grid item md={9} sm={8} xs={12}
                  className={`${Number(access_rights.branches) === 1 ? "disableALlFields" : ""}`}
                >
                  <Prompt
                    when={isBlocking}
                    message={location =>
                      `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                    }
                  />
                  <div className="rightBlock liproCard">
                    <div className="mb2">
                      <label className="mb1">Branche</label>
                      <TextField
                        inputProps={{
                          maxLength: 40
                        }}
                        helperText={errorField ? errorMessage.branch ? errorMessage.branch : errorMessage : ''} error={errorField ? true : false}
                        inputRef={this.textInput} size="small"
                        value={branchField} className="innerInput"
                        onChange={(e) => {
                          this.setState({ branchField: e.target.value, isBlocking: true, errorField: false })
                        }} variant="outlined" />
                    </div>
                    {Number(access_rights.branches) !== 1 &&
                      <div className="actionBtn">
                        {editMode ?
                          <Button variant="outlined" color="primary" onClick={() => { this.editBranch() }} >Speichern</Button>
                          :
                          <Button variant="outlined" color="primary" onClick={() => { this.createBranch() }} >Hinzufügen</Button>
                        }
                        {editMode &&
                          <Button variant="outlined" color="primary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                        }
                      </div>
                    }
                    <Dialog
                      open={isDeleteContactDialogOpen}
                    >
                      <DialogTitle>Branche löschen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          Sind Sie sicher?
              </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.deleteBranch} size="small" variant="outlined" color="primary" autoFocus>
                          Bestätigen
              </Button>
                        <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={accessErrorDialog}
                    >
                      <DialogTitle>Branche</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          {access_error && access_error.message}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Grid>
              </Fragment> :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{errorMessage.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ branches }) => {
  return {
    isloading: branches.loading,
    branches_list: branches.branches_list,
    message_valid: branches.message_valid,
    new_branch: branches.new_branch,
    edited_branch: branches.edited_branch,
    delete_success: branches.success,
    error_validation: branches.error_message,
    access_error: branches.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetBranches: () => dispatch(GetBranches()),
    EditBranch: (id, name) => dispatch(EditBranch(id, name)),
    CreateBranch: (id, name) => dispatch(CreateBranch(id, name)),
    DeleteBranch: (id) => dispatch(DeleteBranch(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Branch)